
export default {

    common: {
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        add: 'Ajouter',
        search: 'Rechercher',
        filter: 'Filtrer',
        export: 'Exporter',
        import: 'Importer',
        loading: 'Chargement...',
        confirm: 'Confirmer',
        back: 'Retour',
        next: 'Suivant',
        previous: 'Précédent',
        close: 'Fermer',
        yes: 'Oui',
        no: 'Non',
        all: 'Tous',
        none: 'Aucun',
        reset: 'Réinitialiser',
        apply: 'Appliquer',
        success: 'Succès',
        error: 'Erreur',
        warning: 'Attention',
        info: 'Information',
        actions: 'Actions',
        status: 'Statut',
        date: 'Date',
        name: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        address: 'Adresse',
        description: 'Description',
        details: 'Détails',
        view: 'Voir',
        download: 'Télécharger',
        upload: 'Téléverser',
        required: 'Requis',
        optional: 'Optionnel',
        deleting: 'Suppression...',
        send: 'Envoyer',
    },


    nav: {
        dashboard: 'Tableau de bord',
        loans: 'Prêts',
        trading: 'Trading',
        esg: 'ESG',
        waivers: 'Dérogations',
        alerts: 'Alertes',
        import: 'Import',
        reports: 'Rapports',
        settings: 'Paramètres',
        help: 'Aide',
        profile: 'Profil',
        team: 'Équipe',
        company: 'Entreprise',
        notifications: 'Notifications',
        roles: 'Rôles & Permissions',
        logout: 'Déconnexion',
        mainMenu: 'Menu principal',
    },


    esg: {
        title: 'Tableau de Bord ESG',
        subtitle: 'Métriques Environnementales, Sociales & de Gouvernance de votre portefeuille',
        greenLoans: 'Prêts Verts',
        sustainabilityLinked: 'Liés à la Durabilité',
        avgEsgScore: 'Score ESG Moyen',
        portfolioAverage: 'Moyenne du portefeuille',
        esgCompliance: 'Conformité ESG',
        covenantsMet: 'Covenants respectés',
        environmentalKpis: 'KPIs Environnementaux',
        carbonIntensity: 'Intensité Carbone',
        renewableEnergy: 'Énergie Renouvelable',
        waterUsage: 'Consommation d\'Eau',
        wasteRecycling: 'Recyclage des Déchets',
        carbonIntensityTrend: 'Tendance Intensité Carbone',
        esgScoreBreakdown: 'Répartition du Score ESG',
        overallEsgScore: 'Score ESG Global',
        sustainableFinanceAllocation: 'Allocation Finance Durable',
        esgCovenants: 'Covenants ESG',
        active: 'actifs',
        greenSustainabilityLoans: 'Prêts Verts & Liés à la Durabilité',
        lmaGreenLoanPrinciples: 'Principes des Prêts Verts LMA',
        lmaAligned: 'Conforme aux Principes des Prêts Verts & Prêts Liés à la Durabilité de la LMA',
        learnMore: 'En savoir plus',
        exportReport: 'Exporter le Rapport',
        euTaxonomyAligned: 'du portefeuille aligné avec la Taxonomie UE',
        target: 'Objectif',
        current: 'Actuel',
        due: 'Échéance',
        excellent: 'Excellent',
        good: 'Bon',
        needsImprovement: 'À améliorer',
        compliant: 'Conforme',
        atRisk: 'À Risque',
        environmental: 'Environnement',
        social: 'Social',
        governance: 'Gouvernance',
    },


    import: {
        title: 'Import de données',
        subtitle: 'Importez des prêts, covenants ou données financières',
    },

    notifications: {
        title: 'Notifications',
        subtitle: 'Gérez vos préférences de notification',
    },

    header: {
        notifications: 'Notifications',
        unread: 'Non lues',
        criticalAlerts: 'Alertes critiques',
        covenantsInBreach: 'Engagements non respectés',
        covenantsApproachingThreshold: 'Engagements proches du seuil',
        noNotifications: 'Aucune notification',
        settings: 'Paramètres',
        warnings: 'Avertissements',
        help: 'Aide',
        myProfile: 'Compte',
        viewAllAlerts: 'Voir toutes les alertes',
        logout: 'Déconnexion',
    },


    auth: {
        login: 'Connexion',
        register: 'Inscription',
        logout: 'Déconnexion',
        forgotPassword: 'Mot de passe oublié ?',
        resetPassword: 'Réinitialiser le mot de passe',
        email: 'Adresse email',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        rememberMe: 'Se souvenir de moi',
        loginButton: 'Se connecter',
        registerButton: 'Créer mon compte',
        noAccount: 'Pas encore de compte ?',
        hasAccount: 'Déjà un compte ?',
        welcomeBack: 'Bienvenue ! Connectez-vous à votre compte',
        createAccount: 'Créer un compte',
        loginSuccess: 'Connexion réussie',
        loginError: 'Email ou mot de passe incorrect',
        registerSuccess: 'Compte créé avec succès !',
        passwordMismatch: 'Les mots de passe ne correspondent pas',
        invalidEmail: 'Veuillez entrer un email valide',
        passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
        demoAccounts: 'Comptes de démonstration',
        selectAccountType: 'Veuillez sélectionner un type de compte',
        firstNameRequired: 'Le prénom est requis',
        lastNameRequired: 'Le nom est requis',
        emailRequired: "L'email est requis",
        companyNameRequired: "Le nom de l'entreprise est requis",
        siretRequired: 'Le numéro SIRET est requis',
        siretInvalid: 'Le numéro SIRET doit contenir 14 chiffres',
        passwordRequired: 'Le mot de passe est requis',
        passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
        passwordStrength: 'Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre',
        termsRequired: "Vous devez accepter les conditions d'utilisation",
        joinThousands: 'Rejoignez des milliers de professionnels',
        startManaging: 'Créez votre compte et commencez à gérer vos covenants financiers de manière efficace et sécurisée.',
        accountType: 'Type de compte',
        accountTypeDesc: 'Entreprise ou Particulier',
        yourInfo: 'Informations',
        yourInfoDesc: 'Vos coordonnées',
        security: 'Sécurité',
        securityDesc: 'Mot de passe sécurisé',
        yourInformation: 'Vos informations',
        secureAccount: 'Sécurisez votre compte',
        chooseAccountType: 'Choisissez votre type de compte',
        companyInfo: 'Informations de votre entreprise',
        personalInfo: 'Vos coordonnées personnelles',
        createSecurePassword: 'Créez un mot de passe sécurisé',
        continue: 'Continuer',
        enterprise: 'Entreprise',
        enterpriseDesc: 'Pour les banques, institutions financières et entreprises',
        multiUsers: 'Multi-utilisateurs',
        teamManagement: "Gestion d'équipe",
        advancedReports: 'Rapports avancés',
        individual: 'Particulier',
        individualDesc: 'Pour les consultants, analystes et indépendants',
        personalAccount: 'Compte personnel',
        fullAccess: 'Accès complet',
        siretNumber: 'Numéro SIRET',
        position: 'Fonction',
        weak: 'Faible',
        medium: 'Moyen',
        strong: 'Fort',
        veryStrong: 'Très fort',
        atLeast8Chars: 'Au moins 8 caractères',
        oneUppercase: 'Une lettre majuscule',
        oneLowercase: 'Une lettre minuscule',
        oneDigit: 'Un chiffre',
        acceptTerms: "J'accepte les",
        termsOfUse: "conditions d'utilisation",
        and: 'et la',
        privacyPolicy: 'politique de confidentialité',
        creatingAccount: 'Création en cours...',
        allRightsReserved: 'Tous droits réservés.',

        featureRealTime: 'Suivi en temps réel',
        featureRealTimeDesc: 'Surveillez vos covenants financiers instantanément',
        featureAlerts: 'Alertes intelligentes',
        featureAlertsDesc: 'Soyez notifié avant les breaches potentiels',
        featureSecurity: 'Sécurité renforcée',
        featureSecurityDesc: 'Vos données sont protégées et chiffrées',
        heroTitle: 'Gérez vos covenants financiers en toute sérénité',
        heroSubtitle: 'La plateforme de référence pour le suivi et la gestion de vos engagements financiers. Anticipez, analysez et agissez.',
        enterEmail: 'Veuillez entrer votre email',
        enterPassword: 'Veuillez entrer votre mot de passe',
        copyright: '© 2025 Covenant Tracker. Tous droits réservés.',

        backToLogin: 'Retour à la connexion',
        forgotPasswordTitle: 'Mot de passe oublié ?',
        forgotPasswordDesc: 'Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
        enterEmailAddress: 'Veuillez entrer votre adresse email',
        sendResetLink: 'Envoyer le lien de réinitialisation',
        sending: 'Envoi en cours...',
        emailSent: 'Email envoyé !',
        emailSentDesc: 'Si un compte existe avec l\'adresse',
        emailSentDesc2: ', vous recevrez un email avec les instructions pour réinitialiser votre mot de passe.',
        checkSpam: 'Vérifiez également votre dossier spam si vous ne voyez pas l\'email.',
        demoNote: 'En mode démo, aucun email n\'est réellement envoyé. Utilisez les comptes de test disponibles sur la page de connexion.',
        note: 'Note',
    },


    loanDetails: {
        title: 'Détails du prêt',
        subtitle: 'Consultez et gérez les informations du prêt',
    },


    dashboard: {
        title: 'Tableau de bord',
        subtitle: 'Vue d\'ensemble de votre portefeuille',
        totalLoans: 'Total des prêts',
        totalAmount: 'Montant total',
        activeCovenants: 'Covenants actifs',
        alertsCount: 'Alertes',
        complianceRate: 'Taux de conformité',
        recentAlerts: 'Alertes récentes',
        upcomingDeadlines: 'Échéances à venir',
        portfolioOverview: 'Aperçu du portefeuille',
        covenantStatus: 'Statut des covenants',
        compliant: 'Conforme',
        atRisk: 'À risque',
        breach: 'En violation',
    },


    loans: {
        title: 'Portefeuille de prêts',
        subtitle: 'Gérez et surveillez votre portefeuille de prêts',
        addLoan: 'Ajouter un prêt',
        editLoan: 'Modifier le prêt',
        deleteLoan: 'Supprimer le prêt',
        loanDetails: 'Détails du prêt',
        issues: 'problèmes',
        borrower: 'Emprunteur',
        lender: 'Prêteur',
        leadArranger: 'Arrangeur principal',
        amount: 'Montant',
        currency: 'Devise',
        interestRate: 'Taux d\'intérêt',
        maturityDate: 'Date d\'échéance',
        startDate: 'Date de début',
        sector: 'Secteur',
        country: 'Pays',
        covenants: 'Covenants',
        covenantCount: 'Nombre de covenants',
        status: 'Statut',
        allStatuses: 'Tous les statuts',
        allSectors: 'Tous les secteurs',
        allCountries: 'Tous les pays',
        noLoansFound: 'Aucun prêt trouvé',
        adjustFilters: 'Essayez d\'ajuster vos critères de recherche',
        viewDetails: 'Voir les détails',
        exportReport: 'Exporter le rapport',
        archive: 'Archiver',
        showing: 'Affichage de',
        to: 'à',
        of: 'sur',
        page: 'Page',
        confirmDeleteTitle: 'Supprimer le prêt',
        confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer ce prêt ?',
        confirmDeleteWarning: 'Cette action est irréversible. Tous les covenants, documents et historique associés seront définitivement supprimés.',
    },


    loanDetail: {

        previewReport: 'Aperçu du rapport',
        preview: 'Aperçu',
        updateData: 'Mettre à jour',
        exportPdf: 'Exporter PDF',
        export: 'Exporter',
        downloaded: 'Téléchargé !',

        tabs: {
            overview: 'Aperçu',
            covenants: 'Covenants',
            history: 'Historique',
            documents: 'Documents',
            esg: 'ESG',
        },

        esg: {
            title: 'Métriques ESG',
            subtitle: 'Performance Environnementale, Sociale & de Gouvernance pour ce prêt',
            submitMetrics: 'Soumettre les métriques',
            covenants: 'Covenants ESG',
            marginAdjustment: 'Ajustement de marge',
            metricsHistory: 'Historique des métriques',
            period: 'Période',
            esgScore: 'Score ESG',
            status: 'Statut',
            verified: 'Vérifié',
            pending: 'En attente',
            noMetrics: 'Aucune métrique ESG soumise',
            clickToSubmit: 'Cliquez sur le bouton ci-dessus pour soumettre votre premier rapport ESG',
            latestMetrics: 'Dernières métriques',
            carbonIntensity: 'Intensité carbone',
            renewableEnergy: 'Énergie renouvelable',
            waterConsumption: 'Consommation d\'eau',
            genderDiversity: 'Diversité de genre',
            lmaCompliance: 'Conformité LMA',
            lmaDescription: 'Ce prêt respecte les principes de finance durable de la LMA',
            glp: 'Principes des Prêts Verts (GLP)',
            sllp: 'Principes des Prêts Liés à la Durabilité (SLLP)',
            submitMetricsTitle: 'Soumettre les métriques ESG',
            submitMetricsSubtitle: 'Déclarez votre performance environnementale, sociale et de gouvernance',
            reportingPeriod: 'Période de reporting',
            overallScores: 'Scores globaux',
            score: 'Score',
            environmentalMetrics: 'Métriques environnementales',
            socialMetrics: 'Métriques sociales',
            submitting: 'Soumission...',
            submitSuccess: 'Métriques ESG soumises avec succès',
            submitError: 'Erreur lors de la soumission des métriques ESG',
            tCO2PerMRevenue: 'tCO2/M€ de CA',
            litersPer1000Revenue: 'litres/1000€ de CA',
            ofWorkforce: 'de l\'effectif',
        },

        loanInformation: 'Informations du prêt',
        leadArranger: 'Chef de file',
        maturityDate: 'Date d\'échéance',
        countrySector: 'Pays / Secteur',
        nextReporting: 'Prochain reporting',

        threshold: 'Seuil',
        headroom: 'marge',
        aboveMin: 'au-dessus du min',
        covenantTrends: 'Tendances des covenants',
        covenantStatus: 'Statut des covenants',
        viewAllCovenants: 'Voir les {count} covenants',
        allCovenants: 'Tous les covenants',
        covenantDetails: 'Détails des covenants',
        covenant: 'Covenant',
        currentValue: 'Valeur actuelle',
        covenantTrendsOverTime: 'Évolution des covenants',

        quickStats: 'Statistiques',
        totalCovenants: 'Total covenants',
        compliant: 'Conforme',
        atRisk: 'À risque',
        breached: 'En violation',
        daysToMaturity: 'Jours avant échéance',

        recentAlerts: 'Alertes récentes',
        noRecentAlerts: 'Aucune alerte récente',

        breachHistory: 'Historique des violations',
        viewFullHistory: 'Voir l\'historique complet',
        resolved: 'Résolu',
        active: 'Actif',
        breachSummary: 'Résumé des violations',
        totalBreaches: 'Total violations',
        breachDetails: 'Détails des violations',
        value: 'Valeur',
        vs: 'vs',

        exportOptions: 'Options d\'export',
        viewBeforeDownload: 'Voir avant téléchargement',
        quickExport: 'Export rapide',
        downloadPdfDirectly: 'Télécharger PDF directement',
        fullReport: 'Rapport complet',
        withHistoricalData: 'Avec données historiques',

        activityHistory: 'Historique d\'activité',
        completeTimeline: 'Chronologie complète des événements pour ce prêt',
        allEvents: 'Tous les événements',
        breaches: 'Violations',
        updates: 'Mises à jour',
        documentsFilter: 'Documents',
        reminders: 'Rappels',
        amendments: 'Amendements',
        timeline: 'Chronologie',
        by: 'par',

        documents: 'Documents',
        documentsAssociated: '{count} documents associés à ce prêt',
        searchDocuments: 'Rechercher des documents...',
        allTypes: 'Tous les types',
        agreements: 'Contrats',
        financial: 'Financier',
        compliance: 'Conformité',
        uploadDocument: 'Téléverser',
        allDocuments: 'Tous les documents',
        document: 'Document',
        type: 'Type',
        size: 'Taille',
        uploadedBy: 'Téléversé par',
        date: 'Date',
        actions: 'Actions',
        noDocuments: 'Aucun document trouvé',

        status: {
            compliant: 'Conforme',
            atRisk: 'À risque',
            breach: 'Violation',
        },

        last6Months: '6 derniers mois',
        last12Months: '12 derniers mois',
        last24Months: '24 derniers mois',
        allStatus: 'Tous les statuts',

        updateCovenantData: 'Mettre à jour les covenants',
        updateCovenantValues: 'Mettre à jour les valeurs des covenants pour ce prêt',
        newValue: 'Nouvelle valeur',
        notes: 'Notes',
        optionalNotes: 'Notes optionnelles sur cette mise à jour',
        saveChanges: 'Enregistrer',
        saving: 'Enregistrement...',
        updateSuccess: 'Valeurs des covenants mises à jour avec succès',
        updateError: 'Erreur lors de la mise à jour des valeurs',

        uploadDocumentTitle: 'Téléverser un document',
        selectFile: 'Sélectionnez un fichier',
        dragAndDrop: 'ou glissez-déposez',
        fileTypes: 'PDF, DOC, DOCX, XLS, XLSX jusqu\'à 10 Mo',
        documentName: 'Nom du document',
        documentType: 'Type de document',
        selectType: 'Sélectionner un type',
        agreement: 'Contrat',
        uploading: 'Téléversement...',
        uploadSuccess: 'Document téléversé avec succès',
        uploadError: 'Erreur lors du téléversement',
    },


    covenants: {
        title: 'Covenants',
        addCovenant: 'Ajouter un covenant',
        editCovenant: 'Modifier le covenant',
        deleteCovenant: 'Supprimer le covenant',
        type: 'Type',
        threshold: 'Seuil',
        currentValue: 'Valeur actuelle',
        targetValue: 'Valeur cible',
        frequency: 'Fréquence',
        nextTest: 'Prochain test',
        lastUpdate: 'Dernière mise à jour',
        updateValue: 'Mettre à jour la valeur',
        history: 'Historique',
        financial: 'Financier',
        nonFinancial: 'Non financier',
        affirmative: 'Affirmatif',
        negative: 'Négatif',
        informational: 'Informationnel',
    },


    alerts: {
        title: 'Alertes',
        subtitle: 'alertes non lues nécessitant votre attention',
        noAlerts: 'Aucune alerte',
        markAsRead: 'Marquer comme lu',
        markAsUnread: 'Marquer comme non lu',
        markAllAsRead: 'Tout marquer comme lu',
        resolve: 'Résoudre',
        delete: 'Supprimer',
        unread: 'Non lues',
        all: 'Toutes',
        critical: 'Critiques',
        warning: 'Avertissements',
        info: 'Informations',
        severity: 'Sévérité',
        source: 'Source',
        createdAt: 'Créée le',
        totalActive: 'Total actif',
        showActive: 'Afficher actives',
        viewArchived: 'Voir archivées',
        archive: 'Archiver',
        noArchivedAlerts: 'Aucune alerte archivée',
        noAlertsFound: 'Aucune alerte trouvée',
        archivedAlertsWillAppearHere: 'Les alertes archivées apparaîtront ici',
        allCaughtUp: 'Tout est à jour ! Aucune alerte ne nécessite votre attention.',
        tryAdjustingFilters: 'Essayez d\'ajuster votre recherche ou vos filtres',
        searchAlerts: 'Rechercher des alertes...',
        filters: 'Filtres',
        type: 'Type',
        allTypes: 'Tous les types',
        status: 'Statut',
        allStatus: 'Tous les statuts',
        read: 'Lues',
        category: 'Catégorie',
        allCategories: 'Toutes les catégories',
        reset: 'Réinitialiser',
        selected: 'sélectionnée',
        selectedPlural: 'sélectionnées',
        viewLoan: 'Voir le prêt',
        readAll: 'Tout lire',
        active: 'Actives',
        archived: 'Archivées',
        alert: 'Alerte',
        loan: 'Prêt',
        time: 'Heure',
        actions: 'Actions',
        showing: 'Affichage de',
        of: 'sur',
        breach: 'Violation',
        approaching: 'Approche du seuil',
        reporting: 'Reporting',
        maturity: 'Échéance',
        compliance: 'Conformité',
    },


    reports: {
        title: 'Rapports',
        subtitle: 'Générez et exportez vos rapports',
        generateReport: 'Générer un rapport',
        scheduleReport: 'Planifier un rapport',
        reportType: 'Type de rapport',
        dateRange: 'Période',
        format: 'Format',
        portfolio: 'Portefeuille',
        compliance: 'Conformité',
        risk: 'Risque',
        custom: 'Personnalisé',
        lastGenerated: 'Dernière génération',
        scheduled: 'Planifié',
        overPeriod: 'sur 6 mois',
        requiresAction: 'nécessite une action',
        avgMaturity: 'Maturité moyenne',
        portfolioAvg: 'moyenne du portefeuille',
        complianceTrend: 'Tendance de conformité',
        historicalView: 'Historique sur 6 mois',
        portfolioStatus: 'Statut du portefeuille',
        currentDistribution: 'Distribution actuelle',
        exposureBySector: 'Exposition par secteur',
        portfolioAllocation: 'Allocation du portefeuille',
        alertsTrend: 'Tendance des alertes',
        monthlyAlertVolume: 'Volume mensuel des alertes',
        geographicExposure: 'Exposition géographique',
        topCountries: 'Principaux pays par valeur',
        covenantHealthBySector: 'Santé des covenants par secteur',
        statusBreakdown: 'Répartition par statut',
        topAtRiskLoans: 'Prêts les plus à risque',
        requiresAttention: 'Nécessitant une attention immédiate',
        portfolioSummary: 'Résumé du portefeuille',
        completeOverview: 'Vue complète par secteur',
        exportToExcel: 'Exporter en Excel',
        exposure: 'Exposition',
        percentPortfolio: '% Portefeuille',
        noData: 'Aucune donnée disponible',
    },


    importPage: {
        title: 'Import de données',
        subtitle: 'Importez des prêts, covenants ou mises à jour financières depuis des fichiers CSV ou Excel',
        dragDrop: 'Glissez-déposez vos fichiers ici',
        or: 'ou',
        browse: 'Parcourir',
        supportedFormats: 'Formats supportés',
        maxSize: 'Taille maximale',
        importing: 'Import en cours...',
        importSuccess: 'Import réussi',
        importError: 'Erreur lors de l\'import',
        preview: 'Aperçu',
        validate: 'Valider',
        mapping: 'Mapping des colonnes',
        import: 'Importer',
        importLoans: 'Importer des prêts',
        importCovenants: 'Importer des covenants',
        importFinancialUpdate: 'Importer une mise à jour financière',
        loansDescription: 'Importez de nouveaux prêts avec les détails de l\'emprunteur, les montants et les dates d\'échéance',
        covenantsDescription: 'Importez des définitions de covenants avec seuils, opérateurs et valeurs actuelles',
        financialUpdateDescription: 'Mettez à jour les valeurs de covenants avec de nouvelles données de reporting financier',
        quickStartGuide: 'Guide de démarrage rapide',
        supportedFormatsTitle: 'Formats supportés',
        numberFormatsTitle: 'Formats de nombres',
        dateFormatsTitle: 'Formats de dates',
        excelFormat: 'Excel (.xlsx, .xls)',
        csvFormat: 'CSV (.csv, .txt)',
        europeanNumberFormat: '€1.500.000,50 (Européen)',
        usNumberFormat: '$1,500,000.50 (US)',
        multiplierFormat: '75M, 1.2B (Multiplicateurs)',
        europeanDateFormat: 'DD/MM/YYYY (Européen)',
        isoDateFormat: 'YYYY-MM-DD (ISO)',
        textDateFormat: '15 June 2025 (Texte)',
        recentImports: 'Imports récents',
        importsCount: 'imports',
        noImportsYet: 'Aucun import pour le moment',
        startImporting: 'Commencez par importer des prêts, covenants ou données financières',
        imported: 'importé',
        importedPlural: 'importés',
        skipped: 'ignoré',
        skippedPlural: 'ignorés',
        loans: 'Prêts',
        covenants: 'Covenants',
        financialUpdate: 'Mise à jour financière',
    },


    settings: {
        title: 'Paramètres',
        subtitle: 'Configurez votre application',
        managePreferences: 'Gérez vos préférences et paramètres de l\'application',
        general: 'Général',
        appearance: 'Apparence',
        notifications: 'Notifications',
        security: 'Sécurité',
        privacy: 'Confidentialité',
        data: 'Données',
        activityLog: 'Journal d\'activité',
        language: 'Langue',
        selectLanguage: 'Sélectionner la langue',
        theme: 'Thème',
        lightTheme: 'Clair',
        darkTheme: 'Sombre',
        autoTheme: 'Automatique',
        systemTheme: 'Système',
        timezone: 'Fuseau horaire',
        dateFormat: 'Format de date',
        numberFormat: 'Format des nombres',
        currency: 'Devise par défaut',
        emailNotifications: 'Notifications par email',
        emailNotificationsDesc: 'Recevez les alertes par email',
        pushNotifications: 'Notifications push',
        pushNotificationsDesc: 'Notifications sur votre navigateur',
        breachAlerts: 'Alertes de breach',
        breachAlertsDesc: 'Quand un covenant est en violation',
        warningAlerts: 'Alertes d\'avertissement',
        warningAlertsDesc: 'Quand un covenant approche du seuil',
        weeklyDigest: 'Résumé hebdomadaire',
        weeklyDigestDesc: 'Recevez un résumé chaque lundi',
        alertThresholds: 'Seuils d\'alerte',
        twoFactor: 'Authentification à deux facteurs',
        sessions: 'Sessions actives',
        changePassword: 'Changer le mot de passe',
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        confirmNewPassword: 'Confirmer le nouveau mot de passe',
        savedSuccessfully: 'Paramètres enregistrés avec succès',
        saveError: 'Erreur lors de l\'enregistrement des paramètres',
        globalNotificationConfig: 'Configuration globale des notifications',
        globalNotificationConfigDesc: 'En tant qu\'administrateur, vous pouvez configurer le serveur SMTP, les règles d\'alertes globales, les webhooks et plus encore.',
        configureNotifications: 'Configurer les notifications',
        personalPreferences: 'Préférences personnelles',
        yourPreferences: 'Vos préférences',
        notificationPreferences: 'Préférences de notification',
        appearanceDisplay: 'Apparence et affichage',
        display: 'Affichage',
        compactMode: 'Mode compact',
        compactModeDesc: 'Réduire l\'espacement pour afficher plus d\'informations',
        privacySecurity: 'Confidentialité et sécurité',
        profileVisibility: 'Visibilité du profil',
        public: 'Public',
        publicDesc: 'Visible par tous les utilisateurs',
        teamOnly: 'Équipe',
        teamOnlyDesc: 'Visible uniquement par votre équipe',
        private: 'Privé',
        privateDesc: 'Visible uniquement par vous',
        otherOptions: 'Autres options',
        showActivityStatus: 'Afficher mon statut d\'activité',
        showActivityStatusDesc: 'Les autres peuvent voir quand vous êtes en ligne',
        shareAnalytics: 'Partager les analyses d\'utilisation',
        shareAnalyticsDesc: 'Nous aider à améliorer l\'application',
        dataManagement: 'Gestion des données',
        exportData: 'Exporter vos données',
        exportDataDesc: 'Téléchargez une copie de toutes vos données au format JSON ou CSV',
        exportDataButton: 'Exporter les données',
        exportDataPreparing: 'Export des données en cours de préparation...',
        deleteAccount: 'Supprimer le compte',
        deleteAccountDesc: 'Cette action est irréversible. Toutes vos données seront définitivement supprimées.',
        deleteAccountButton: 'Supprimer mon compte',
        activityLogDesc: 'Consultez toutes les actions et événements du système',
        total: 'Total',
        last24h: 'Dernières 24h',
        connections: 'Connexions',
        errors24h: 'Erreurs (24h)',
        allTypes: 'Tous les types',
        allCategories: 'Toutes catégories',
        purge: 'Purger',
        purgeConfirm: 'Supprimer les logs de plus de 30 jours ?',
        oldLogsPurged: 'Anciens logs supprimés',
        logsExported: 'Logs exportés en {format}',
        noLogsFound: 'Aucun log trouvé',
        showingFirst: 'Affichage des 50 premiers résultats sur {total}',
        logDetails: 'Détails du log',
        user: 'Utilisateur',
        type: 'Type',
        category: 'Catégorie',
        action: 'Action',
        ipAddress: 'Adresse IP',
        details: 'Détails',
        teamManagement: 'Gestion de l\'équipe',
        teamManagementDesc: 'Gérez les membres et les rôles de votre équipe',
        manageTeam: 'Gérer l\'équipe',
        accessFullManagement: 'Accédez à la gestion complète',
        accessFullManagementDesc: 'Invitez de nouveaux membres, gérez les rôles et les permissions depuis la page dédiée à la gestion d\'équipe.',
        fullTeamAccess: 'Accédez à la gestion complète',
        fullTeamAccessDesc: 'Invitez de nouveaux membres, gérez les rôles et les permissions depuis la page dédiée à la gestion d\'équipe.',
        inviteByEmail: 'Inviter des membres par email',
        assignRoles: 'Attribuer et modifier les rôles',
        managePendingInvites: 'Gérer les invitations en attente',
        trackMemberActivity: 'Suivre l\'activité des membres',
        teamFeatures: {
            invite: 'Inviter des membres par email',
            roles: 'Attribuer et modifier les rôles',
            invitations: 'Gérer les invitations en attente',
            activity: 'Suivre l\'activité des membres',
        },
        saving: 'Sauvegarde...',
        saveChanges: 'Sauvegarder les modifications',
        logTypes: {
            connection: 'Connexion',
            action: 'Action',
            error: 'Erreur',
            session: 'Session',
            config: 'Config',
            security: 'Sécurité',
        },
    },


    profile: {
        title: 'Mon profil',
        subtitle: 'Gérez vos informations personnelles',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Email',
        emailNotEditable: 'Non modifiable',
        phone: 'Téléphone',
        company: 'Entreprise',
        position: 'Fonction',
        role: 'Rôle',
        joinedAt: 'Membre depuis',
        lastActive: 'Dernière activité',
        editProfile: 'Modifier le profil',
        uploadAvatar: 'Changer la photo',
        removeAvatar: 'Supprimer la photo',
        accountSettings: 'Paramètres du compte',
        updateSuccess: 'Profil mis à jour avec succès',
        updateError: 'Erreur lors de la mise à jour',
        informations: 'Informations',
        personalInfo: 'Informations personnelles',
        accountInfo: 'Informations du compte',
        createdDate: 'Date de création',
        verifiedAccount: 'Compte vérifié',
        status: 'Statut',
        loansManaged: 'Prêts gérés',
        compliance: 'Conformité',
        changePhoto: 'Changer la photo',
        selectPhoto: 'Sélectionner une photo',
        removePhoto: 'Supprimer',
        avatarRequirements: 'PNG, JPG ou GIF. Max 2 Mo.',
        avatarSizeError: 'L\'image ne doit pas dépasser 2 Mo',
        avatarUpdateSuccess: 'Photo mise à jour avec succès',
        avatarUpdateError: 'Erreur lors de la mise à jour de la photo',
        avatarRemoved: 'Photo supprimée',
        passwordChangeSuccess: 'Mot de passe modifié avec succès',
        passwordChangeError: 'Erreur lors du changement de mot de passe',
        passwordTooShortError: 'Le nouveau mot de passe doit contenir au moins 8 caractères',
        passwordMismatchError: 'Les mots de passe ne correspondent pas',
        passwordHint: 'Assurez-vous d\'utiliser un mot de passe fort et unique',
        currentSession: 'Session actuelle',
        activeNow: 'Actif maintenant',
        changingPassword: 'Modification en cours...',
    },


    team: {
        title: 'Gestion de l\'équipe',
        subtitle: 'Gérez les membres de votre équipe',
        members: 'Membres',
        inviteMember: 'Inviter un membre',
        pendingInvitations: 'Invitations en attente',
        removeMember: 'Retirer le membre',
        changeRole: 'Changer le rôle',
        modifyRole: 'Modifier le rôle',
        active: 'Actif',
        inactive: 'Inactif',
        pending: 'En attente',
        inviteByEmail: 'Inviter par email',
        sendInvitation: 'Envoyer l\'invitation',
        invitationSent: 'Invitation envoyée',
        resendInvitation: 'Renvoyer l\'invitation',
        cancelInvitation: 'Annuler l\'invitation',
        you: 'Vous',
        memberSince: 'Membre depuis',
        online: 'En ligne',
        minutesAgo: 'Il y a {minutes} min',
        hoursAgo: 'Il y a {hours}h',
        daysAgo: 'Il y a {days}j',
        removeFromTeam: 'Retirer de l\'équipe',
        noMemberFound: 'Aucun membre trouvé',
        invitations: 'Invitations',
        invitedBy: 'Invité par',
        expiresOn: 'Expire le',
        invitationExpired: 'Invitation expirée',
        resend: 'Renvoyer',
        cancel: 'Annuler',
        noInvitationPending: 'Aucune invitation en attente',
        availableRoles: 'Rôles disponibles',
        emailAddress: 'Adresse email',
        assignedRole: 'Rôle attribué',
        customMessage: 'Message personnalisé (optionnel)',
        customMessagePlaceholder: 'Ajouter un message à l\'invitation...',
        sending: 'Envoi...',
        current: 'Actuel',
        emailInvalid: 'Veuillez entrer un email valide',
        userAlreadyMember: 'Cet utilisateur est déjà membre de l\'équipe',
        invitationAlreadyPending: 'Une invitation est déjà en attente pour cet email',
        invitationSentTo: 'Invitation envoyée à {email}',
        roleUpdatedSuccess: 'Rôle mis à jour avec succès',
        confirmRemoveMember: 'Êtes-vous sûr de vouloir retirer ce membre de l\'équipe ?',
        memberRemoved: 'Membre retiré de l\'équipe',
        invitationCancelled: 'Invitation annulée',
        invitationResent: 'Invitation renvoyée',
    },


    roles: {
        title: 'Rôles et Permissions',
        subtitle: 'Documentation des droits d\'accès par rôle',

        agent: 'Facility Agent',
        agentDesc: 'Vue complète du portefeuille, gestion des covenants et administration de la plateforme',
        lender: 'Prêteur',
        lenderDesc: 'Surveillance des prêts et covenants sur vos expositions au syndicat',
        borrower: 'Emprunteur',
        borrowerDesc: 'Gérez vos prêts, mettez à jour les données financières et le reporting',

        admin: 'Administrateur',
        adminDesc: 'Accès complet à toutes les fonctionnalités et paramètres',
        manager: 'Manager',
        managerDesc: 'Gestion des prêts, alertes et supervision de l\'équipe',
        analyst: 'Analyste',
        analystDesc: 'Création et analyse des prêts et covenants',
        viewer: 'Lecteur',
        viewerDesc: 'Consultation des données en lecture seule',
        reader: 'Lecteur',
        currentRole: 'Votre rôle actuel',
        permissions: 'permissions',
        permissionMatrix: 'Matrice des permissions',
        granted: 'Accordée',
        denied: 'Non accordée',
        allPermissions: 'Toutes les permissions',
        partialPermissions: 'Permissions partielles',
        accessRestricted: 'Accès restreint',
        noAccessMessage: 'Vous n\'avez pas accès à cette page.',
    },


    lma: {

        facilityTypes: {
            term_loan_a: 'Prêt à Terme A',
            term_loan_b: 'Prêt à Terme B',
            rcf: 'Crédit Renouvelable (RCF)',
            capex: 'Facilité Capex',
            acquisition: 'Facilité d\'Acquisition',
            green_loan: 'Prêt Vert',
            sustainability_linked: 'Prêt lié à la Durabilité',
            bridge: 'Prêt Relais',
            other: 'Autre',
        },

        participantRoles: {
            lead_arranger: 'Arrangeur Principal',
            co_arranger: 'Co-Arrangeur',
            bookrunner: 'Teneur de Livre',
            participant: 'Participant',
            sub_participant: 'Sous-Participant',
        },

        covenantTypes: {
            financial: 'Financier',
            non_financial: 'Non-Financier',
            esg: 'ESG',
            informational: 'Informatif',
        },

        covenantCategories: {
            leverage: 'Levier',
            coverage: 'Couverture',
            liquidity: 'Liquidité',
            capex: 'Capex',
            dividend: 'Dividende',
            esg: 'ESG',
            reporting: 'Reporting',
            other: 'Autre',
        },

        covenantNames: {
            debt_ebitda: 'Dette Nette / EBITDA',
            interest_coverage: 'Ratio de Couverture des Intérêts',
            debt_service: 'Ratio de Couverture du Service de la Dette',
            current_ratio: 'Ratio de Liquidité Générale',
            min_ebitda: 'EBITDA Minimum',
            max_capex: 'Capex Maximum',
            leverage_ratio: 'Ratio de Levier',
            carbon_intensity: 'Intensité Carbone',
            renewable_energy: '% Énergie Renouvelable',
        },

        status: {
            compliant: 'Conforme',
            at_risk: 'À Risque',
            breach: 'Violation',
        },

        fields: {
            facilityName: 'Nom de la Facilité',
            facilityType: 'Type de Facilité',
            facilityAmount: 'Montant de la Facilité',
            drawnAmount: 'Montant Tiré',
            availableAmount: 'Montant Disponible',
            margin: 'Marge',
            referenceRate: 'Taux de Référence',
            signingDate: 'Date de Signature',
            maturityDate: 'Date d\'Échéance',
            tenorMonths: 'Durée (Mois)',
            nextReportingDate: 'Prochaine Date de Reporting',
            reportingFrequency: 'Fréquence de Reporting',
            leadArranger: 'Arrangeur Principal',
            syndicate: 'Membres du Syndicat',
            participation: 'Participation',
            greenLoan: 'Prêt Vert',
            esgLinked: 'Lié ESG',
        },

        frequencies: {
            monthly: 'Mensuel',
            quarterly: 'Trimestriel',
            semi_annual: 'Semestriel',
            annual: 'Annuel',
        },

        referenceRates: {
            euribor: 'EURIBOR',
            sofr: 'SOFR',
            sonia: 'SONIA',
            libor: 'LIBOR',
        },

        institutionTypes: {
            facility_agent: 'Agent de la Facilité',
            bank: 'Banque',
            corporate: 'Entreprise',
            fund: 'Fonds',
        },
    },


    permissionCategories: {
        dashboard: 'Tableau de bord',
        loans: 'Prêts',
        covenants: 'Covenants',
        alerts: 'Alertes',
        reports: 'Rapports',
        import: 'Import de données',
        team: 'Équipe',
        settings: 'Paramètres',
        logs: 'Journaux',
    },


    permissions: {
        view_dashboard: 'Voir le tableau de bord',
        view_dashboard_stats: 'Voir les statistiques globales',
        view_dashboard_charts: 'Voir les graphiques',
        view_loans: 'Voir les prêts',
        view_loan_details: 'Voir les détails d\'un prêt',
        create_loan: 'Créer un prêt',
        edit_loan: 'Modifier un prêt',
        delete_loan: 'Supprimer un prêt',
        archive_loan: 'Archiver un prêt',
        view_covenants: 'Voir les covenants',
        create_covenant: 'Créer un covenant',
        edit_covenant: 'Modifier un covenant',
        delete_covenant: 'Supprimer un covenant',
        update_covenant_value: 'Mettre à jour les valeurs',
        view_alerts: 'Voir les alertes',
        manage_alerts: 'Gérer les alertes',
        configure_alerts: 'Configurer les seuils d\'alerte',
        delete_alerts: 'Supprimer les alertes',
        view_reports: 'Voir les rapports',
        create_report: 'Créer des rapports',
        export_reports: 'Exporter les rapports',
        schedule_reports: 'Planifier des rapports automatiques',
        import_data: 'Importer des données',
        import_bulk: 'Import en masse',
        import_validate: 'Valider les imports',
        view_team: 'Voir les membres de l\'équipe',
        invite_member: 'Inviter des membres',
        manage_roles: 'Gérer les rôles',
        remove_member: 'Retirer des membres',
        view_settings: 'Voir les paramètres',
        manage_settings: 'Modifier les paramètres',
        manage_company: 'Configurer l\'entreprise',
        manage_notifications: 'Configurer les notifications globales',
        manage_integrations: 'Gérer les intégrations',
        view_logs: 'Voir les journaux d\'activité',
        export_logs: 'Exporter les journaux',
        delete_logs: 'Purger les journaux',
    },


    companySettings: {
        title: 'Configuration entreprise',
        subtitle: 'Paramètres de votre organisation',
        companyName: 'Nom de l\'entreprise',
        legalName: 'Raison sociale',
        legalNamePlaceholder: 'Raison sociale complète',
        siret: 'SIRET',
        vatNumber: 'Numéro de TVA',
        logo: 'Logo',
        uploadLogo: 'Téléverser un logo',
        primaryColor: 'Couleur principale',
        secondaryColor: 'Couleur secondaire',
        branding: 'Branding',
        billing: 'Facturation',
        invoicePrefix: 'Préfixe de facture',
        defaultCurrency: 'Devise par défaut',

        generalInfo: 'Informations générales',
        contact: 'Coordonnées',
        legalInfo: 'Informations légales',
        billingSettings: 'Paramètres de facturation',

        tradeName: 'Nom commercial',
        companyDescription: 'Description de l\'entreprise',
        descriptionPlaceholder: 'Décrivez votre activité...',
        industry: 'Secteur d\'activité',
        companySize: 'Taille de l\'entreprise',
        foundedYear: 'Année de création',
        website: 'Site web',

        addressPlaceholder: 'Numéro et rue',
        addressLine2: 'Complément d\'adresse',
        addressLine2Placeholder: 'Bâtiment, étage, etc.',
        postalCode: 'Code postal',
        city: 'Ville',
        cityPlaceholder: 'Ville',
        country: 'Pays',
        contactEmail: 'Email de contact',

        importantInfo: 'Information importante',
        legalInfoWarning: 'Ces informations sont utilisées pour la génération des documents légaux et factures. Assurez-vous qu\'elles sont exactes et à jour.',
        siretNumber: 'Numéro SIRET',
        sirenNumber: 'Numéro SIREN',
        '14digits': '14 chiffres',
        '9digits': '9 chiffres',
        rcs: 'RCS',
        rcsPlaceholder: 'Ville B XXX XXX XXX',
        legalForm: 'Forme juridique',
        apeCode: 'Code APE/NAF',
        shareCapital: 'Capital social',

        billingEmail: 'Email de facturation',
        paymentTerms: 'Délai de paiement (jours)',
        immediatePayment: 'Paiement immédiat',
        '15days': '15 jours',
        '30days': '30 jours',
        '45days': '45 jours',
        '60days': '60 jours',
        '90days': '90 jours',
        billingAddress: 'Adresse de facturation',
        billingAddressPlaceholder: 'Adresse complète de facturation',
        bankDetails: 'Coordonnées bancaires',
        iban: 'IBAN',
        bic: 'BIC/SWIFT',
        bankName: 'Nom de la banque',
        bankNamePlaceholder: 'Nom de votre banque',

        companyLogo: 'Logo de l\'entreprise',
        noLogo: 'Pas de logo',
        logoRequirements: 'PNG, JPG ou SVG. Max 2 Mo. Recommandé: 512x512px',
        brandColors: 'Couleurs de marque',
        preview: 'Aperçu',
        exampleButton: 'Bouton exemple',

        saving: 'Sauvegarde...',
        saveChanges: 'Sauvegarder les modifications',
        logoSizeError: 'Le logo ne doit pas dépasser 2 Mo',
        updateSuccess: 'Informations de l\'entreprise mises à jour avec succès. Le branding a été appliqué globalement.',

        enterpriseOnly: 'Cette section est réservée aux comptes entreprise. Veuillez mettre à niveau votre compte pour accéder à ces fonctionnalités.',
        upgradeToEnterprise: 'Mettre à niveau vers Entreprise',

        industries: {
            finance: 'Finance & Banque',
            insurance: 'Assurance',
            consulting: 'Conseil',
            technology: 'Technologie',
            healthcare: 'Santé',
            manufacturing: 'Industrie',
            retail: 'Commerce',
            realEstate: 'Immobilier',
            energy: 'Énergie',
            other: 'Autre',
        },

        sizes: {
            '1-10': '1-10 employés',
            '11-50': '11-50 employés',
            '51-200': '51-200 employés',
            '201-500': '201-500 employés',
            '501-1000': '501-1000 employés',
            '1001-5000': '1001-5000 employés',
            '5001-10000': '5001-10000 employés',
            '10000+': 'Plus de 10000 employés',
        },

        legalForms: {
            sa: 'Société Anonyme (SA)',
            sas: 'Société par Actions Simplifiée (SAS)',
            sarl: 'SARL',
            eurl: 'EURL',
            sca: 'Société en Commandite par Actions (SCA)',
            snc: 'Société en Nom Collectif (SNC)',
            ei: 'Entreprise Individuelle',
            other: 'Autre',
        },

        countries: {
            belgium: 'Belgique',
            switzerland: 'Suisse',
            germany: 'Allemagne',
            italy: 'Italie',
            spain: 'Espagne',
            uk: 'Royaume-Uni',
            netherlands: 'Pays-Bas',
            other: 'Autre',
        },
    },


    help: {
        title: 'Centre d\'aide',
        subtitle: 'Trouvez des réponses à vos questions ou contactez notre équipe support',
        gettingStarted: 'Démarrage',
        faq: 'Questions fréquentes',
        documentation: 'Documentation',
        docDescription: 'Guide complet de l\'application',
        support: 'Support',
        contactUs: 'Contactez-nous',
        contactUsSubtitle: 'Réponse sous 24h',
        tutorials: 'Tutoriels vidéo',
        tutorialsDescription: 'Apprenez en regardant',
        security: 'Sécurité & Informations légales',
        securitySubtitle: 'Protection des données et conformité',
        cgu: 'Conditions Générales',
        cguDescription: 'CGU et conditions d\'utilisation du service',
        privacy: 'Politique de confidentialité',
        privacyDescription: 'Comment nous protégeons vos données',
        cookies: 'Politique des cookies',
        cookiesDescription: 'Gestion des cookies et traceurs',
        securityPolicy: 'Sécurité des données',
        securityPolicyDescription: 'Nos mesures de protection',
        searchPlaceholder: 'Rechercher dans l\'aide...',
        noResults: 'Aucun résultat pour',
        clearSearch: 'Effacer la recherche',
        quickLinks: 'Liens rapides',
        apiDocumentation: 'API Documentation',
        apiDescription: 'Pour les développeurs',
        otherContactMethods: 'Autres moyens de contact',
        systemStatus: 'Statut du système',
        allSystemsOperational: 'Tous les systèmes opérationnels',
        lastUpdate: 'Dernière mise à jour',
        ago: 'il y a',
        min: 'min',
        contactForm: {
            subject: 'Sujet',
            subjectPlaceholder: 'Votre question...',
            priority: 'Priorité',
            priorityLow: 'Basse',
            priorityNormal: 'Normale',
            priorityHigh: 'Haute',
            priorityUrgent: 'Urgente',
            message: 'Message',
            messagePlaceholder: 'Décrivez votre problème...',
            send: 'Envoyer',
            sending: 'Envoi en cours...',
            success: 'Votre message a été envoyé. Nous vous répondrons sous 24h.',
            error: 'Veuillez remplir tous les champs',
            errorGeneric: 'Une erreur est survenue lors de l\'envoi du message. Veuillez réessayer.',
        },
        categories: {
            gettingStarted: 'Démarrage',
            loans: 'Gestion des prêts',
            covenants: 'Covenants',
            alerts: 'Alertes',
            reports: 'Rapports',
            import: 'Import de données',
            users: 'Utilisateurs',
            settings: 'Paramètres',
        },
        emailLabel: 'Email',
        emailAddress: 'support@covenant-tracker.com',
        phoneLabel: 'Téléphone',
        phoneNumber: '+33 1 23 45 67 89',
        phoneHours: 'Lun-Ven, 9h-18h',
        understood: 'J\'ai compris',
        lastUpdated: 'Dernière mise à jour',
        lastUpdatedDate: '1er janvier 2025',
        gdprCompliant: 'RGPD Compliant',
        encryption: 'Chiffrement AES-256',
        euHosting: 'Hébergement UE',
        twoFactorAvailable: '2FA disponible',

        modals: {
            cgu: {
                title: 'Conditions Générales d\'Utilisation',
                lastUpdated: 'Dernière mise à jour',
                lastUpdatedDate: '1er janvier 2025',
                section1Title: '1. Objet',
                section1Content: 'Les présentes Conditions Générales d\'Utilisation (CGU) régissent l\'accès et l\'utilisation de l\'application Covenant Tracker, éditée par Covenant Tracker SAS. En accédant à l\'application, vous acceptez sans réserve les présentes CGU.',
                section2Title: '2. Description du service',
                section2Content: 'Covenant Tracker est une application de gestion et de suivi des covenants financiers. Elle permet aux utilisateurs de :',
                section2List: ['Créer et gérer des prêts et leurs covenants associés', 'Suivre les indicateurs financiers en temps réel', 'Recevoir des alertes en cas de dépassement de seuils', 'Générer des rapports et des analyses'],
                section3Title: '3. Accès au service',
                section3Content: 'L\'accès au service nécessite la création d\'un compte utilisateur. Vous êtes responsable de la confidentialité de vos identifiants et de toutes les activités effectuées sous votre compte.',
                section4Title: '4. Obligations de l\'utilisateur',
                section4Content: 'L\'utilisateur s\'engage à :',
                section4List: ['Fournir des informations exactes et à jour', 'Ne pas utiliser le service à des fins illicites', 'Respecter les droits de propriété intellectuelle', 'Ne pas tenter de compromettre la sécurité du service'],
                section5Title: '5. Propriété intellectuelle',
                section5Content: 'L\'ensemble des éléments constituant l\'application (logiciels, bases de données, textes, images, etc.) sont la propriété exclusive de Covenant Tracker SAS et sont protégés par les lois relatives à la propriété intellectuelle.',
                section6Title: '6. Limitation de responsabilité',
                section6Content: 'Covenant Tracker ne saurait être tenu responsable des dommages directs ou indirects résultant de l\'utilisation ou de l\'impossibilité d\'utiliser le service. Les données présentées sont fournies à titre indicatif.',
                section7Title: '7. Modification des CGU',
                section7Content: 'Covenant Tracker se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés de toute modification par notification dans l\'application.',
                section8Title: '8. Droit applicable',
                section8Content: 'Les présentes CGU sont régies par le droit français. Tout litige sera soumis à la compétence exclusive des tribunaux de Paris.',
            },
            privacy: {
                title: 'Politique de confidentialité',
                lastUpdated: 'Dernière mise à jour',
                lastUpdatedDate: '1er janvier 2025',
                section1Title: '1. Responsable du traitement',
                section1Content: 'Covenant Tracker SAS, société par actions simplifiée au capital de 50 000 euros, dont le siège social est situé au 16 Boulevard des Italiens, 75009 Paris, France.',
                section1Email: 'Email : privacy@covenant-tracker.com',
                section2Title: '2. Données collectées',
                section2Content: 'Nous collectons les catégories de données suivantes :',
                section2List: ['Données d\'identification : nom, prénom, email, téléphone', 'Données professionnelles : entreprise, fonction, secteur d\'activité', 'Données financières : informations sur les prêts et covenants', 'Données de connexion : logs, adresse IP, type de navigateur'],
                section3Title: '3. Finalités du traitement',
                section3Content: 'Vos données sont traitées pour :',
                section3List: ['La gestion de votre compte utilisateur', 'La fourniture et l\'amélioration de nos services', 'L\'envoi de notifications et d\'alertes', 'Le respect de nos obligations légales', 'L\'analyse statistique et l\'amélioration de l\'expérience utilisateur'],
                section4Title: '4. Base légale',
                section4Content: 'Le traitement de vos données repose sur :',
                section4List: ['L\'exécution du contrat de service', 'Votre consentement (pour les cookies non essentiels)', 'Notre intérêt légitime (amélioration du service)', 'Le respect d\'obligations légales'],
                section5Title: '5. Durée de conservation',
                section5Content: 'Vos données sont conservées pendant la durée de votre utilisation du service, puis pendant une durée de 3 ans après la fin de la relation commerciale, sauf obligation légale de conservation plus longue.',
                section6Title: '6. Vos droits',
                section6Content: 'Conformément au RGPD, vous disposez des droits suivants :',
                section6List: ['Droit d\'accès : obtenir une copie de vos données', 'Droit de rectification : corriger vos données inexactes', 'Droit à l\'effacement : demander la suppression de vos données', 'Droit à la portabilité : recevoir vos données dans un format structuré', 'Droit d\'opposition : vous opposer au traitement de vos données', 'Droit à la limitation : limiter le traitement de vos données'],
                section6Contact: 'Pour exercer ces droits : privacy@covenant-tracker.com',
                section7Title: '7. Transferts de données',
                section7Content: 'Vos données sont hébergées au sein de l\'Union Européenne. En cas de transfert vers un pays tiers, des garanties appropriées seront mises en place conformément au RGPD.',
                section8Title: '8. Réclamation',
                section8Content: 'Vous pouvez introduire une réclamation auprès de la CNIL (Commission Nationale de l\'Informatique et des Libertés) : www.cnil.fr',
            },
            cookies: {
                title: 'Politique des cookies',
                lastUpdated: 'Dernière mise à jour',
                lastUpdatedDate: '1er janvier 2025',
                section1Title: '1. Qu\'est-ce qu\'un cookie ?',
                section1Content: 'Un cookie est un petit fichier texte déposé sur votre terminal (ordinateur, tablette, smartphone) lors de la visite d\'un site web. Il permet de stocker des informations relatives à votre navigation.',
                section2Title: '2. Types de cookies utilisés',
                essential: 'Cookies essentiels (obligatoires)',
                essentialDesc: 'Ces cookies sont nécessaires au fonctionnement de l\'application. Ils permettent l\'authentification, la sécurité et la mémorisation de vos préférences.',
                essentialList: ['Session utilisateur', 'Jeton d\'authentification', 'Préférences de langue'],
                analytics: 'Cookies analytiques (optionnels)',
                analyticsDesc: 'Ces cookies nous aident à comprendre comment vous utilisez l\'application afin d\'améliorer nos services.',
                analyticsList: ['Pages visitées', 'Durée des sessions', 'Fonctionnalités utilisées'],
                personalization: 'Cookies de personnalisation (optionnels)',
                personalizationDesc: 'Ces cookies permettent de personnaliser votre expérience en mémorisant vos préférences.',
                personalizationList: ['Thème (clair/sombre)', 'Disposition du tableau de bord', 'Filtres et vues préférées'],
                section3Title: '3. Durée de conservation',
                cookieType: 'Type de cookie',
                duration: 'Durée',
                session: 'Session',
                sessionDuration: 'Jusqu\'à fermeture du navigateur',
                authentication: 'Authentification',
                authDuration: '30 jours (si "Se souvenir de moi")',
                preferences: 'Préférences',
                prefDuration: '1 an',
                analyticsDuration: '13 mois',
                section4Title: '4. Gérer vos préférences',
                section4Content: 'Vous pouvez à tout moment modifier vos préférences en matière de cookies dans les Paramètres de l\'application, section "Confidentialité".',
                section4Content2: 'Vous pouvez également configurer votre navigateur pour refuser les cookies. Notez que certaines fonctionnalités pourraient ne plus être disponibles.',
            },
            security: {
                title: 'Sécurité des données',
                priority: 'La sécurité de vos données financières est notre priorité absolue.',
                encryption: 'Chiffrement des données',
                encryptionTransit: 'En transit : Toutes les communications sont chiffrées via TLS 1.3',
                encryptionRest: 'Au repos : Chiffrement AES-256 pour toutes les données stockées',
                encryptionPasswords: 'Mots de passe : Hachage bcrypt avec salt individuel',
                authentication: 'Authentification',
                twoFactor: '2FA : Authentification à deux facteurs disponible (TOTP, SMS)',
                sessions: 'Sessions : Expiration automatique et révocation à distance',
                detection: 'Détection : Alertes en cas de connexion suspecte',
                infrastructure: 'Infrastructure',
                euHosting: 'Hébergement UE : Serveurs situés en France et en Allemagne',
                backups: 'Sauvegardes : Sauvegardes quotidiennes chiffrées, rétention 30 jours',
                availability: 'Disponibilité : SLA 99.9% avec monitoring 24/7',
                ddos: 'DDoS : Protection contre les attaques par déni de service',
                compliance: 'Conformité & Audits',
                gdpr: 'RGPD : Pleine conformité avec le règlement européen',
                audits: 'Audits : Tests de pénétration annuels par des experts indépendants',
                logs: 'Logs : Journalisation complète des accès et modifications',
                reportVulnerability: 'Signaler une vulnérabilité',
                reportVulnerabilityContent: 'Si vous découvrez une faille de sécurité, veuillez nous contacter immédiatement à :',
            },
        },
        faqContent: {
            gettingStarted: [
                {
                    question: "Comment créer mon premier prêt ?",
                    answer: "Pour créer un prêt, accédez à la page 'Prêts' depuis le menu latéral, puis cliquez sur le bouton 'Nouveau prêt'. Suivez l'assistant en 4 étapes pour renseigner les informations de base, les détails du prêt, définir les covenants et valider."
                },
                {
                    question: "Qu'est-ce qu'un covenant ?",
                    answer: "Un covenant est une clause contractuelle dans un accord de prêt qui impose certaines conditions à l'emprunteur. Il peut s'agir de ratios financiers à maintenir (ex: ratio de dette/EBITDA inférieur à 3x), de seuils minimaux (ex: ratio de liquidité supérieur à 1.2), ou d'obligations de reporting."
                },
                {
                    question: "Comment naviguer dans l'application ?",
                    answer: "Utilisez le menu latéral à gauche pour accéder aux différentes sections : Dashboard pour une vue d'ensemble, Prêts pour gérer vos prêts, Alertes pour suivre les notifications, Rapports pour les analyses, et Import pour ajouter des données."
                },
            ],
            loans: [
                {
                    question: "Comment modifier un prêt existant ?",
                    answer: "Depuis la page Prêts, cliquez sur les trois points (...) à droite du prêt concerné et sélectionnez 'Modifier'. Vous pouvez également accéder aux détails du prêt en cliquant dessus, puis utiliser le bouton 'Modifier' en haut de la page."
                },
                {
                    question: "Puis-je supprimer un prêt ?",
                    answer: "Oui, vous pouvez supprimer un prêt depuis le menu d'actions (...). Attention : cette action est irréversible et supprimera également tous les covenants et l'historique associés. Une confirmation vous sera demandée."
                },
                {
                    question: "Comment filtrer les prêts par statut ?",
                    answer: "Sur la page Prêts, utilisez les filtres en haut de la liste. Vous pouvez filtrer par statut (Conforme, À risque, Breach), par secteur d'activité, par pays, ou utiliser la barre de recherche pour trouver un prêt spécifique."
                },
            ],
            covenants: [
                {
                    question: "Comment ajouter un covenant à un prêt ?",
                    answer: "Lors de la création d'un prêt, l'étape 3 vous permet de définir les covenants. Vous pouvez choisir parmi des templates prédéfinis ou créer des covenants personnalisés. Pour un prêt existant, modifiez-le et accédez à la section covenants."
                },
                {
                    question: "Comment sont calculés les statuts des covenants ?",
                    answer: "Le statut est calculé automatiquement en comparant la valeur actuelle au seuil défini, selon l'opérateur choisi (>, <, >=, <=). Un covenant est 'Conforme' si la condition est respectée, 'À risque' s'il approche du seuil (dans les 10%), et 'Breach' si la condition n'est pas respectée."
                },
                {
                    question: "Quels types de covenants puis-je créer ?",
                    answer: "Vous pouvez créer des covenants de type ratio (ex: Debt/EBITDA), valeur absolue (ex: EBITDA minimum), ou pourcentage (ex: marge opérationnelle). Chaque covenant peut avoir un opérateur de comparaison et un seuil personnalisés."
                },
            ],
            alerts: [
                {
                    question: "Comment configurer mes notifications ?",
                    answer: "Accédez aux Paramètres > Notifications pour configurer vos préférences. Vous pouvez choisir de recevoir des alertes par email et/ou push, définir les types d'alertes (breach, warning, reporting) et activer le résumé hebdomadaire."
                },
                {
                    question: "Que signifient les différents types d'alertes ?",
                    answer: "Les alertes sont classées en trois catégories : Critique (rouge) pour les breaches de covenants, Avertissement (orange) pour les valeurs approchant des seuils, et Information (bleu) pour les rappels de reporting et autres notifications."
                },
                {
                    question: "Comment marquer une alerte comme traitée ?",
                    answer: "Cliquez sur l'alerte pour voir ses détails, puis utilisez le bouton 'Marquer comme lu' ou 'Archiver'. Les alertes archivées restent consultables dans l'onglet 'Archivées' de la page Alertes."
                },
            ],
            reports: [
                {
                    question: "Comment générer un rapport ?",
                    answer: "Accédez à la page Rapports et sélectionnez le type de rapport souhaité (Conformité, Performance, Tendances). Configurez les filtres et la période, puis cliquez sur 'Générer'. Vous pouvez ensuite exporter le rapport en PDF ou Excel."
                },
                {
                    question: "Puis-je personnaliser les rapports ?",
                    answer: "Oui, chaque type de rapport offre des options de personnalisation. Vous pouvez choisir les métriques à afficher, la période d'analyse, les prêts à inclure, et le format d'export (PDF, Excel)."
                },
                {
                    question: "Comment programmer des rapports automatiques ?",
                    answer: "Dans Paramètres > Notifications, activez l'option 'Résumé hebdomadaire' pour recevoir automatiquement un rapport de synthèse chaque lundi. Des options de rapports automatiques plus avancées sont disponibles pour les comptes Entreprise."
                },
            ],
            import: [
                {
                    question: "Quels formats de fichiers sont supportés ?",
                    answer: "L'application supporte les formats CSV et Excel (XLSX). Les fichiers doivent respecter un format spécifique avec des colonnes obligatoires. Un template est téléchargeable depuis la page Import."
                },
                {
                    question: "Comment résoudre les erreurs d'import ?",
                    answer: "Si l'import échoue, vérifiez que votre fichier respecte le format attendu (colonnes, types de données). Les erreurs les plus courantes sont des colonnes manquantes, des formats de date incorrects, ou des valeurs numériques mal formatées."
                },
                {
                    question: "Puis-je mettre à jour des données existantes ?",
                    answer: "Oui, lors de l'import, vous pouvez choisir de mettre à jour les prêts existants (basé sur la référence du prêt) ou de créer uniquement de nouveaux enregistrements. Les doublons sont automatiquement détectés."
                },
            ],
            users: [
                {
                    question: "Comment inviter un nouveau membre à mon équipe ?",
                    answer: "Accédez à Paramètres > Équipe (disponible pour les administrateurs et managers), puis cliquez sur 'Inviter'. Entrez l'email du nouveau membre et sélectionnez son rôle. Il recevra un email d'invitation."
                },
                {
                    question: "Quels sont les différents rôles disponibles ?",
                    answer: "Il existe 4 rôles : Admin (accès complet), Manager (gestion d'équipe et prêts), Analyst (création et analyse), et Viewer (lecture seule). Chaque rôle a des permissions spécifiques détaillées dans Paramètres > Équipe."
                },
                {
                    question: "Comment modifier le rôle d'un utilisateur ?",
                    answer: "Dans Paramètres > Équipe, cliquez sur le membre concerné puis modifiez son rôle dans le menu déroulant. Seuls les administrateurs peuvent modifier les rôles des autres utilisateurs."
                },
            ],
            settings: [
                {
                    question: "Comment changer la langue de l'application ?",
                    answer: "Accédez à Paramètres > Apparence et sélectionnez votre langue préférée dans le menu déroulant. L'application supporte actuellement le Français, l'Anglais, l'Allemand et l'Espagnol."
                },
                {
                    question: "Comment activer le mode sombre ?",
                    answer: "Dans Paramètres > Apparence, choisissez 'Sombre' dans la section Thème. Vous pouvez également sélectionner 'Système' pour suivre automatiquement les préférences de votre appareil."
                },
                {
                    question: "Comment exporter mes données ?",
                    answer: "Accédez à Paramètres > Données et cliquez sur 'Exporter les données'. Vous recevrez un fichier ZIP contenant toutes vos données au format JSON, incluant prêts, covenants, alertes et historique."
                },
            ],
        },
    },



    errors: {
        notFound: 'Page introuvable',
        notFoundMessage: 'La page que vous recherchez n\'existe pas ou a été déplacée.',
        unauthorized: 'Accès non autorisé',
        unauthorizedMessage: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette page.',
        serverError: 'Erreur serveur',
        serverErrorMessage: 'Une erreur inattendue s\'est produite. Veuillez réessayer plus tard.',
        backToHome: 'Retour à l\'accueil',
        goBack: 'Page précédente',
    },


    confirmations: {
        deleteTitle: 'Confirmer la suppression',
        deleteMessage: 'Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.',
        logoutTitle: 'Déconnexion',
        logoutMessage: 'Êtes-vous sûr de vouloir vous déconnecter ?',
        unsavedChanges: 'Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter ?',
    },


    dateTime: {
        today: 'Aujourd\'hui',
        yesterday: 'Hier',
        tomorrow: 'Demain',
        thisWeek: 'Cette semaine',
        lastWeek: 'Semaine dernière',
        thisMonth: 'Ce mois',
        lastMonth: 'Mois dernier',
        last3Months: '3 derniers mois',
        last6Months: '6 derniers mois',
        thisYear: 'Cette année',
        lastYear: 'Année dernière',
        daysAgo: 'il y a {count} jours',
        hoursAgo: 'il y a {count} heures',
        minutesAgo: 'il y a {count} minutes',
        justNow: 'À l\'instant',
    },


    formats: {
        date: 'DD/MM/YYYY',
        dateTime: 'DD/MM/YYYY HH:mm',
        time: 'HH:mm',
        currency: '{amount} {currency}',
        percentage: '{value}%',
    },


    team: {
        title: 'Gestion de l\'équipe',
        subtitle: 'Gérez les membres de votre équipe',
        members: 'Membres',
        invitations: 'Invitations',
        inviteMember: 'Inviter un membre',
        pendingInvitations: 'invitations en attente',
        membersCount: 'membre',
        membersCountPlural: 'membres',
        searchPlaceholder: 'Rechercher...',
        you: 'Vous',
        memberSince: 'Membre depuis',
        online: 'En ligne',
        minutesAgo: 'Il y a {count} min',
        hoursAgo: 'Il y a {count}h',
        daysAgo: 'Il y a {count}j',
        noMembersFound: 'Aucun membre trouvé',
        noInvitations: 'Aucune invitation en attente',
        availableRoles: 'Rôles disponibles',
        editRole: 'Modifier le rôle',
        removeFromTeam: 'Retirer de l\'équipe',
        invitedBy: 'Invité par',
        expiresOn: 'Expire le',
        invitationExpired: 'Invitation expirée',
        resend: 'Renvoyer',
        cancelInvitation: 'Annuler',
        inviteModal: {
            title: 'Inviter un membre',
            emailLabel: 'Adresse email *',
            emailPlaceholder: 'collegue@company.com',
            roleLabel: 'Rôle attribué *',
            messageLabel: 'Message personnalisé (optionnel)',
            messagePlaceholder: 'Ajouter un message à l\'invitation...',
            cancel: 'Annuler',
            send: 'Envoyer l\'invitation',
            sending: 'Envoi...',
        },
        editRoleModal: {
            title: 'Modifier le rôle',
            current: 'Actuel',
        },
        deleteModal: {
            title: 'Retirer un membre',
            message: 'Êtes-vous sûr de vouloir retirer ce membre de l\'équipe ?',
            warning: 'Cette action est irréversible. L\'utilisateur perdra l\'accès à toutes les ressources de l\'équipe.',
            confirm: 'Retirer',
        },
        messages: {
            validEmailRequired: 'Veuillez entrer un email valide',
            alreadyMember: 'Cet utilisateur est déjà membre de l\'équipe',
            invitationPending: 'Une invitation est déjà en attente pour cet email',
            invitationSent: 'Invitation envoyée à',
            roleUpdated: 'Rôle mis à jour avec succès',
            memberRemoved: 'Membre retiré de l\'équipe',
            invitationCancelled: 'Invitation annulée',
            invitationResent: 'Invitation renvoyée',
        },
        emailInvalid: 'Veuillez entrer un email valide',
        userAlreadyMember: 'Cet utilisateur est déjà membre de l\'équipe',
        invitationAlreadyPending: 'Une invitation est déjà en attente pour cet email',
        invitationSentTo: 'Invitation envoyée à',
        roleUpdatedSuccess: 'Rôle mis à jour avec succès',
        memberRemovedSuccess: 'Membre retiré de l\'équipe',
        invitationCancelledSuccess: 'Invitation annulée',
        invitationResentSuccess: 'Invitation renvoyée',
        confirmRemove: 'Êtes-vous sûr de vouloir retirer ce membre de l\'équipe ?',
        cancel: 'Annuler',
    },


    unauthorized: {
        title: 'Accès non autorisé',
        message: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette page. Contactez votre administrateur si vous pensez qu\'il s\'agit d\'une erreur.',
        backToDashboard: 'Retour au Dashboard',
        previousPage: 'Page précédente',
    },


    rolesPermissions: {
        title: 'Rôles et Permissions',
        subtitle: 'Documentation complète des droits d\'accès par rôle',
        restrictedAccess: 'Accès restreint',
        noAccessMessage: 'Vous n\'avez pas accès à la documentation des rôles et permissions.',
        yourCurrentRole: 'Votre rôle actuel',
        youHave: 'Vous disposez de',
        permissionsOf: 'permissions sur',
        available: 'disponibles',
        you: 'Vous',
        permissionMatrix: 'Matrice des permissions',
        permissionMatrixDesc: 'Comparaison des accès par rôle et catégorie',
        permission: 'Permission',
        legend: 'Légende',
        permissionGranted: 'Permission accordée',
        permissionDenied: 'Permission non accordée',
        allPermissions: 'Toutes les permissions de la catégorie',
        partialPermissions: 'Permissions partielles',
    },


    trading: {
        title: 'Trading Secondaire',
        subtitle: 'Marketplace de participations - Achetez et vendez des positions de prêts syndiqués',
        newOrder: 'Nouvel ordre',
        refresh: 'Actualiser',
        openOrders: 'Ordres ouverts',
        tradeHistory: 'Historique des transactions',
        buy: 'Achat',
        sell: 'Vente',
        all: 'Tous',
        amount: 'Montant',
        price: 'Prix',
        expires: 'Expire',
        borrower: 'Emprunteur',
        facility: 'Facilité',
        seller: 'Vendeur',
        buyer: 'Acheteur',
        date: 'Date',
        settled: 'Réglé',
        noOrders: 'Aucun ordre ouvert',
        searchPlaceholder: 'Rechercher par emprunteur ou facilité...',
        buyFrom: 'Acheter',
        sellTo: 'Vendre',
        orderType: 'Type d\'ordre',
        selectLoan: 'Sélectionner un prêt',
        chooseLoan: 'Choisir un prêt...',
        participationAmount: 'Montant de la participation',
        pricePercent: 'Prix (%)',
        priceHint: '100% = valeur nominale. En dessous de 100 = décote, au-dessus de 100 = prime',
        validFor: 'Valide pendant',
        day: 'jour',
        days: 'jours',
        placeOrder: 'Passer l\'ordre',
        status: {
            open: 'Ouvert',
            matched: 'Exécuté',
            cancelled: 'Annulé',
            expired: 'Expiré',
        },
        stats: {
            openOrders: 'Ordres ouverts',
            tradedVolume: 'Volume négocié (30j)',
            avgPrice: 'Prix moyen',
            activeParticipants: 'Participants actifs',
        },
        marketInfo: {
            title: 'Marché Européen des Prêts à Effet de Levier',
            subtitle: 'Données de marché en temps réel des membres LMA',
            weeklyVolume: 'Volume hebdomadaire',
            weeklyChange: 'vs. semaine dernière',
        },
    },


    notificationSettings: {
        title: 'Configuration des notifications',
        subtitle: 'Configurez les emails, alertes et intégrations de notification',
        restricted: {
            title: 'Accès restreint',
            message: 'Seuls les administrateurs peuvent accéder à la configuration des notifications.',
        },
        tabs: {
            smtp: 'Configuration SMTP',
            alerts: 'Règles d\'alertes',
            templates: 'Templates emails',
            webhooks: 'Webhooks',
            advanced: 'Avancé',
        },
        status: {
            title: 'État de la configuration',
            enabled: 'activé',
            disabled: 'désactivé',
            enabledFem: 'activées',
            disabledFem: 'désactivées',
        },
        messages: {
            saved: 'Configuration sauvegardée avec succès',
            enterEmail: 'Veuillez entrer une adresse email',
            webhookRequired: 'Veuillez remplir le nom et l\'URL du webhook',
            webhookAdded: 'Webhook ajouté avec succès',
            configReset: 'Configuration réinitialisée',
        },
        smtp: {
            title: 'Configuration SMTP',
            subtitle: 'Paramètres du serveur de messagerie',
            server: 'Serveur SMTP',
            host: 'Hôte SMTP',
            port: 'Port',
            portUnsecured: 'Non sécurisé',
            recommended: 'Recommandé',
            alternate: 'Alternatif',
            secureConnection: 'Connexion sécurisée (SSL/TLS)',
            secureConnectionDesc: 'Recommandé pour la sécurité des données',
            authentication: 'Authentification',
            username: 'Nom d\'utilisateur',
            password: 'Mot de passe',
            sender: 'Expéditeur',
            senderEmail: 'Email expéditeur',
            displayName: 'Nom affiché',
            replyTo: 'Email de réponse (Reply-To)',
            replyToPlaceholder: 'support@example.com (optionnel)',
            testConfig: 'Tester la configuration',
            testConnection: 'Tester la connexion',
            testEmailPlaceholder: 'Email de test',
            popularPresets: 'Presets populaires',
        },
        alerts: {
            title: 'Alertes',
            rulesTitle: 'Règles d\'alertes',
            enableAlerts: 'Activer les alertes',
            enableAlertsDesc: 'Activer/désactiver toutes les notifications d\'alerte',
            alertTypes: 'Types d\'alertes',
            breach: 'Breach (Critique)',
            breachDesc: 'Dépassement de seuil de covenant',
            warning: 'Warning (Avertissement)',
            warningDesc: 'Approche du seuil (10%)',
            info: 'Info (Information)',
            infoDesc: 'Rappels et notifications générales',
            channels: 'Canaux par type d\'alerte',
            timing: 'Timing des notifications',
            immediateAlerts: 'Notifications immédiates',
            immediateAlertsDesc: 'Envoyer les alertes dès qu\'elles sont détectées',
            digest: 'Digest (regroupement)',
            digestDesc: 'Regrouper les alertes non urgentes',
            hourly: 'Toutes les heures',
            daily: 'Quotidien',
            weekly: 'Hebdomadaire',
            quietHours: 'Heures silencieuses',
            enableQuietHours: 'Activer les heures silencieuses',
            enableQuietHoursDesc: 'Ne pas envoyer de notifications pendant certaines heures',
            from: 'De',
            to: 'à',
            excludeUrgent: 'Exclure les alertes urgentes (Breach)',
            excludeUrgentDesc: 'Toujours envoyer les alertes critiques',
            autoReports: 'Rapports automatiques',
            weeklyReport: 'Rapport hebdomadaire',
            weeklyReportDesc: 'Résumé des covenants chaque semaine',
            monthlyReport: 'Rapport mensuel',
            monthlyReportDesc: 'Analyse détaillée chaque mois',
            monday: 'Lundi',
            tuesday: 'Mardi',
            wednesday: 'Mercredi',
            thursday: 'Jeudi',
            friday: 'Vendredi',
        },
        templates: {
            title: 'Templates d\'emails',
            customization: 'Personnalisation',
            useCompanyBranding: 'Utiliser le branding de l\'entreprise',
            useCompanyBrandingDesc: 'Appliquer le logo et les couleurs de l\'entreprise',
            headerColor: 'Couleur d\'en-tête',
            footerText: 'Texte de pied de page',
            unsubscribeLink: 'Inclure le lien de désinscription',
            unsubscribeLinkDesc: 'Requis par le RGPD',
            preview: 'Aperçu',
            previewGreeting: 'Bonjour,',
            previewContent: 'Ceci est un aperçu de vos emails de notification...',
        },
        webhooks: {
            title: 'Webhooks',
            subtitle: 'Intégrations avec des services externes',
            noWebhooks: 'Aucun webhook configuré',
            newWebhook: 'Nouveau webhook',
            name: 'Nom',
            url: 'URL',
            events: 'Événements',
            secret: 'Secret (pour signature HMAC)',
            secretPlaceholder: 'Optionnel',
            generate: 'Générer',
            add: 'Ajouter',
            addWebhook: 'Ajouter un webhook',
        },
        advanced: {
            title: 'Paramètres avancés',
            limits: 'Limites de notification',
            maxEmailsPerDay: 'Max emails par jour',
            maxPushPerHour: 'Max push par heure',
            logging: 'Journalisation',
            enableLogs: 'Activer les logs d\'envoi',
            enableLogsDesc: 'Conserver un historique des notifications envoyées',
            logRetention: 'Rétention des logs (jours)',
            dangerZone: 'Zone dangereuse',
            dangerZoneDesc: 'Réinitialiser tous les paramètres de notification à leurs valeurs par défaut.',
            resetConfig: 'Réinitialiser',
            confirmReset: 'Êtes-vous sûr de vouloir réinitialiser tous les paramètres ?',
        },
        save: 'Sauvegarder',
        saving: 'Sauvegarde...',
    },


    waivers: {
        title: 'Dérogations aux Covenants',
        subtitle: 'Gérer les demandes de dérogation et approbations',
        newRequest: 'Nouvelle demande',
        searchPlaceholder: 'Rechercher par emprunteur, covenant ou ID...',
        allStatus: 'Tous les statuts',
        totalRequests: 'Demandes totales',
        pendingReview: 'En attente',
        underVoting: 'En cours de vote',
        approved: 'Approuvées',
        rejected: 'Rejetées',
        noWaivers: 'Aucune demande de dérogation',
        noWaiversDescription: 'Créez une nouvelle demande ou ajustez vos filtres',

        status: {
            draft: 'Brouillon',
            pending_review: 'En attente de révision',
            negotiating: 'En négociation',
            under_voting: 'En cours de vote',
            approved: 'Approuvée',
            rejected: 'Rejetée',
            expired: 'Expirée',
            withdrawn: 'Retirée',
        },

        current: 'Actuel',
        threshold: 'Seuil',
        votingProgress: 'Progression du vote',
        approval: 'Approbation',
        requiredMajority: 'Majorité requise',
        deadline: 'Échéance',

        approve: 'Approuver',
        reject: 'Rejeter',
        for: 'Pour',
        against: 'Contre',
        received: 'Reçus',
        pendingVotes: 'votes en attente',
        votingStatus: 'État du vote',

        selectLoan: 'Sélectionner un prêt',
        selectLoanPlaceholder: 'Choisir un prêt...',
        covenantName: 'Nom du covenant',
        covenantType: 'Type de covenant',
        currentValue: 'Valeur actuelle',
        thresholdValue: 'Valeur seuil',
        requestedWaiver: 'Dérogation demandée',
        justification: 'Justification',
        justificationPlaceholder: 'Expliquez pourquoi cette dérogation est nécessaire et le plan de retour à la conformité...',
        supportingDocuments: 'Documents justificatifs',
        dragDropFiles: 'Glissez-déposez les fichiers ou cliquez pour parcourir',
        saveDraft: 'Enregistrer brouillon',
        submitForReview: 'Soumettre pour révision',

        types: {
            financial: 'Financier',
            operational: 'Opérationnel',
            reporting: 'Reporting',
            other: 'Autre',
        },

        simpleMajority: 'Majorité simple',
        superMajority: 'Super majorité',
        qualifiedMajority: 'Majorité qualifiée',
        unanimity: 'Unanimité',

        covenantDetails: 'Détails du covenant',
        comments: 'Commentaires',
        noComments: 'Aucun commentaire',
        addCommentPlaceholder: 'Ajouter un commentaire...',
        timeline: 'Chronologie',
        requestCreated: 'Demande créée',
        votingDeadline: 'Date limite de vote',
        requestInfo: 'Informations de la demande',
        requestedBy: 'Demandé par',
        totalLenders: 'Total des prêteurs',

        agentAction: 'Action agent requise',
        agentReviewMessage: 'Examinez cette demande de dérogation et décidez si vous l\'ouvrez au vote des prêteurs.',
        openForVoting: 'Ouvrir au vote',
        requestMoreInfo: 'Demander plus d\'infos',

        tabs: {
            details: 'Détails',
            negotiation: 'Négociation',
        },

        negotiation: {
            title: 'Historique des négociations',
            round: 'Tour',
            initialProposal: 'Proposition initiale',
            counterProposal: 'Contre-proposition',
            current: 'En cours',
            superseded: 'Remplacée',
            conditions: 'Conditions',
            accept: 'Accepter',
            counter: 'Contre-proposer',
            makeCounter: 'Faire une contre-proposition',
            yourProposal: 'Votre proposition',
            proposalPlaceholder: 'Décrivez votre contre-proposition...',
            condition: 'Condition',
            addCondition: 'Ajouter une condition',
            submitCounter: 'Soumettre la contre-proposition',
            agentMessage: 'Une fois les parties d\'accord sur les termes, vous pouvez finaliser et ouvrir le vote formel.',
            finalizeAndVote: 'Finaliser et ouvrir le vote',
        },
    },
};
